


















































































import { PropType } from 'vue';
import { defineComponent, toRefs, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, CreateMode, EstimatedType, AudienceSizeTipsType } from '@tt4b/ttam-enums';
import TtamAudienceSize from './index';
import { i18n } from '@tt4b/ttam-i18n';
import TipAlert from '@/components/common/tip-alert/index.vue';

const name = 'ttam-audience-size-tips-compose';
export default defineComponent({
  name,
  components: {
    TtamAudienceSizeTargetExpansionTip: TtamAudienceSize.TtamAudienceSizeTargetExpansionTip,
    TipAlert,
  },
  props: {
    estimateType: {
      type: Number as PropType<EstimatedType>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props) {
    const { campaignData, adgroupData, estimateType } = toRefs(props);
    const { ageTipVisible } = TtamAudienceSize.usePropsAgeTipVisible({
      adgroupData,
      estimateType,
    });
    const { broadTipVisible } = TtamAudienceSize.usePropsBroadTipVisible({
      estimateType,
    });
    const { locationTipVisible } = TtamAudienceSize.usePropsLocationTipVisible({
      adgroupData,
    });

    const { narrowTipVisible } = TtamAudienceSize.usePropsNarrowTipVisible({
      estimateType,
      adgroupData,
    });
    const { targetExpansionTipVisible } = TtamAudienceSize.usePropsTargetExpansionTipVisible({
      adgroupData,
    });
    const { ttpCloverTipVisible } = TtamAudienceSize.usePropsTtpTipVisible();

    const { estimateRightBarErrorKey } = TtamAudienceSize.useTtpCloverUnsupportedTips();

    const { claTipVisible, psaTipVisible, noEstimatePrompt } = TtamAudienceSize.usePropsTipVisible({
      adgroupData,
      campaignData,
    });

    const infoTips = computed(() =>
      [
        {
          type: AudienceSizeTipsType.Info,
          component: 'ttam-audience-size-target-expansion-tip',
          isShow: targetExpansionTipVisible.value,
        },
      ].filter(({ isShow }) => isShow),
    );

    const noticeTips = computed(() =>
      [
        {
          type: AudienceSizeTipsType.Notice,
          content: i18n.t('module_adgroup_cla_audience_tips'),
          isShow: claTipVisible.value,
        },
        {
          type: AudienceSizeTipsType.Notice,
          content: i18n.t('module_adgroup_psa_audience_tips'),
          isShow: psaTipVisible.value,
        },
        {
          type: AudienceSizeTipsType.Notice,
          content: i18n.t('audience_estimate_tips_disabled'),
          isShow: !noEstimatePrompt.value && locationTipVisible.value,
        },
        {
          type: AudienceSizeTipsType.Notice,
          content: i18n.t('module_adgroup_audience_estimate_age_tip'),
          isShow: !noEstimatePrompt.value && ageTipVisible.value,
        },
        {
          type: AudienceSizeTipsType.Notice,
          content: i18n.t('audience_estimate_tips_broad'),
          isShow: !noEstimatePrompt.value && broadTipVisible.value,
        },
      ].filter(({ isShow }) => isShow),
    );

    const warningTips = computed(() =>
      [
        {
          type: AudienceSizeTipsType.Warning,
          content: i18n.t('audience_estimate_tips_too_narrow'),
          isShow: !noEstimatePrompt.value && narrowTipVisible.value,
          dataTeaExpose: 'create_adgroup_too_narrow_expose',
        },
      ].filter(({ isShow }) => isShow),
    );

    const errorTips = computed(() =>
      [
        {
          type: AudienceSizeTipsType.Error,
          content: i18n.t(estimateRightBarErrorKey.value),
          isShow: !noEstimatePrompt.value && ttpCloverTipVisible.value,
        },
      ].filter(({ isShow }) => isShow),
    );

    return {
      name,
      infoTips,
      noticeTips,
      warningTips,
      errorTips,
    };
  },
});
